import styled, {css, SimpleInterpolation} from 'styled-components';
import Media from "../../assets/styles/media";

export const ScheduleCtn = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
  flex-direction: column;
`;

export const TableCtn = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ExportCtn = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`;
